import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { useSearchParams } from "react-router-dom";

const ErrorPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const reason = searchParams.get("reason") || "invalid_token";

  const messages = {
    invalid_token: {
      title: t("errorInvalidTokenTitle"),
      description: t("errorInvalidTokenDescription"),
    },
    expired_token: {
      title: t("errorExpiredTokenTitle"),
      description: t("errorExpiredTokenDescription"),
    },
    missing_token: {
      title: t("errorMissingTokenTitle"),
      description: t("errorMissingTokenDescription"),
    },
    missing_restaurant: {
      title: t("errorMissingRestaurantTitle"),
      description: t("errorMissingRestaurantDescription"),
    },
    menu_load_failed: {
      title: t("errorMenuLoadFailedTitle"),
      description: t("errorMenuLoadFailedDescription"),
    },
    menu_not_found: {
      title: t("errorMenuNotFoundTitle"),
      description: t("errorMenuNotFoundDescription"),
    },
  };

  const { title, description } = messages[reason] || messages.invalid_token;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      className="flex flex-col items-center justify-center min-h-screen bg-background p-6 text-center gap-6 w-full"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4, delay: 0.1, type: "spring", stiffness: 200 }}
        className="w-16 h-16 rounded-full bg-secondary text-muted flex items-center justify-center"
      >
        <svg
          className="w-8 h-8"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4.5c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
          />
        </svg>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.25 }}
        className="flex flex-col gap-2"
      >
        <h1 className="text-lg font-bold text-dark">{title}</h1>
        <p className="text-sm text-muted max-w-xs">{description}</p>
      </motion.div>
    </motion.div>
  );
};

export default ErrorPage;
